import env from '../get-env'

export function getEnv () {
  return env()
}
